var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('create-account-form',{attrs:{"with-access":""},on:{"created":_vm.onAccountCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }